module.exports = __webpack_public_path__ + "img/img_brand12.7020dcde.jpg";